const aspectRatioPercentage = (ratio: string = '1:1') => {
  const ratioArr: string[] = ratio.split(':');
  const width: number = parseFloat(ratioArr[0]);
  const height: number = parseFloat(ratioArr[1]);

  // Calculate percentage value using 'width' and 'height'
  return (height / width) * 100;
};

export default aspectRatioPercentage;
